import React, { useState } from "react";

import PropTypes from "prop-types";

import "./faq-personal.css";

const FAQPersonal = (props) => {
  const [faq2Visible, setFaq2Visible] = useState(false);
  const [faq1Visible, setFaq1Visible] = useState(false);
  const [faq3Visible, setFaq3Visible] = useState(false);
  const [faq4Visible, setFaq4Visible] = useState(false);
  const [faq5Visible, setFaq5Visible] = useState(false);
  return (
    <section
      id="faq"
      className={`faq-personal-faq8 thq-section-padding ${props.rootClassName} `}
    >
      <div className="faq-personal-column">
        <span className="faq-personal-text10">{props.text}</span>
        <div className="faq-personal-max-width thq-section-max-width">
          <div className="faq-personal-container10 thq-flex-column">
            <div className="thq-flex-column thq-section-max-width">
              <div className="thq-divider-horizontal"></div>
              <div className="faq-personal-faq1">
                <div
                  onClick={() => setFaq1Visible(!faq1Visible)}
                  className="faq-personal-trigger1"
                >
                  <p className="faq-personal-faq1-question1 thq-body-large">
                    {props.faq1Question}
                  </p>
                  <div className="faq-personal-icons-container1">
                    {faq1Visible === false && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon10"
                        >
                          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                        </svg>
                      </div>
                    )}
                    {faq1Visible === true && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon12"
                        >
                          <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {faq1Visible === true && (
                  <div className="faq-personal-container13">
                    <span className="thq-body-small">
                      <span>
                        For fees and details about our services, tap
                        <span
                          dangerouslySetInnerHTML={{
                            __html: " ",
                          }}
                        />
                      </span>
                      <a
                        href={process.env.REACT_APP_FEES_URL}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="faq-personal-text13"
                      >
                        here
                      </a>
                      <span>
                        . Always refer to this list to be updated about the fees
                        and changes in pricing of any service.
                      </span>
                    </span>
                  </div>
                )}
              </div>
              <div className="thq-divider-horizontal"></div>
              <div className="faq-personal-faq2">
                <div
                  onClick={() => setFaq2Visible(!faq2Visible)}
                  className="faq-personal-trigger2"
                >
                  <p className="faq-personal-faq2-question1 thq-body-large">
                    {props.faq2Question}
                  </p>
                  <div className="faq-personal-icons-container2">
                    {faq2Visible === false && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon14"
                        >
                          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                        </svg>
                      </div>
                    )}
                    {faq2Visible === true && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon16"
                        >
                          <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {faq2Visible === true && (
                  <div className="faq-personal-container16">
                    <span className="thq-body-small">
                      {" "}
                      CashOver is supoorted across Lebanon. Payments can be done
                      through our partners, from personal users to merchants and
                      businesses.
                    </span>
                  </div>
                )}
              </div>
              <div className="thq-divider-horizontal"></div>
              <div className="faq-personal-faq3">
                <div
                  onClick={() => setFaq3Visible(!faq3Visible)}
                  className="faq-personal-trigger3"
                >
                  <p className="faq-personal-faq2-question2 thq-body-large">
                    {props.faq3Question}
                  </p>
                  <div className="faq-personal-icons-container3">
                    {faq3Visible === false && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon18"
                        >
                          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                        </svg>
                      </div>
                    )}
                    {faq3Visible === true && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon20"
                        >
                          <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {faq3Visible === true && (
                  <div className="faq-personal-container19">
                    <span className="thq-body-small">
                      <ul>
                        <li>
                          <strong>
                            Receive funds from other CashOver users
                          </strong>{" "}
                          – Accept instant transfers from verified CashOver
                          accounts directly into your balance.
                        </li>
                        <li>
                          <strong>Deposit cash at agents or ATMs</strong> – Add
                          funds at any authorized CashOver agent location or
                          supported ATM.
                        </li>
                        <li>
                          <strong>Sell your crypto balance</strong> – Convert
                          crypto you hold on the platform into CashOver funds
                          instantly.
                        </li>
                        <li>
                          <strong>Top up your crypto wallet</strong> – Send
                          crypto to your unique CashOver wallet address or
                          purchase crypto through the platform.
                        </li>
                      </ul>
                      <p>
                        For more information, please refer to our guides{" "}
                        <a
                          style={{
                            textDecoration: "underline",
                            color: "#0b6ef9ff",
                          }}
                          href={process.env.REACT_APP_DOCS_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          here
                        </a>
                        .
                      </p>
                    </span>
                  </div>
                )}
              </div>
              <div className="thq-divider-horizontal"></div>
              <div className="faq-personal-faq4">
                <div
                  onClick={() => setFaq4Visible(!faq4Visible)}
                  className="faq-personal-trigger4"
                >
                  <p className="faq-personal-faq2-question3 thq-body-large">
                    {props.faq4Question}
                  </p>
                  <div className="faq-personal-icons-container4">
                    {faq4Visible === false && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon22"
                        >
                          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                        </svg>
                      </div>
                    )}
                    {faq4Visible === true && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon24"
                        >
                          <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {faq4Visible === true && (
                  <div className="faq-personal-container22">
                    <span className="thq-body-small">
                      <ul>
                        <li>
                          <strong>Open the CashOver app</strong> on your mobile
                          device.
                        </li>
                        <li>
                          Navigate to the <strong>Settings</strong> section.
                        </li>
                        <li>
                          Tap <strong>CashOver Partners</strong> to access the
                          interactive <strong>CashOver Map</strong>.
                        </li>
                        <li>
                          View all nearby authorized agents, ATMs, and partner
                          locations that provide CashOver services.
                        </li>
                      </ul>
                      <p>
                        The CashOver Map makes it quick and easy to find the
                        nearest location to deposit, withdraw, or access our
                        partner services.
                      </p>
                    </span>
                  </div>
                )}
              </div>
              <div className="thq-divider-horizontal"></div>
              <div className="faq-personal-faq5">
                <div
                  onClick={() => setFaq5Visible(!faq5Visible)}
                  className="faq-personal-trigger5"
                >
                  <p className="faq-personal-faq1-question2 thq-body-large">
                    {props.faq5Question}
                  </p>
                  <div className="faq-personal-icons-container5">
                    {faq5Visible === false && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon26"
                        >
                          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                        </svg>
                      </div>
                    )}
                    {faq5Visible === true && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-personal-icon28"
                        >
                          <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {faq5Visible === true && (
                  <div className="faq-personal-container25">
                    <span className="thq-body-small">
                      <span>
                        CashOver supports Binance Smart Chain network. Make sure
                        that every deposit that you do is over the BSC network.
                        If you are not familiar with BSC network, refer to this
                        <span
                          dangerouslySetInnerHTML={{
                            __html: " ",
                          }}
                        />
                      </span>
                      <a
                        href="https://academy.binance.com/en/articles/connecting-metamask-to-binance-smart-chain"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="faq-personal-link1"
                      >
                        guide here
                      </a>
                      <span> for more info to get you started.</span>
                    </span>
                  </div>
                )}
              </div>
              <div className="thq-divider-horizontal"></div>
            </div>
          </div>
          <div className="faq-personal-content thq-flex-column thq-section-max-width">
            <h2 className="faq-personal-text22">{props.heading2}</h2>
            <p className="faq-personal-text23">{props.content2}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

FAQPersonal.defaultProps = {
  faq5Question: "What network does CashOver support?",
  content2: "Do not hesitate to contact us to answer your inquiries",
  faq1Question: "Where can I check CashOver fees?",
  heading2: "Still have a question?",
  text: "FAQ",
  faq3Question: "How can I topup my CashOver wallet Balance?",
  faq4Question: "How to locate a CashOver agent or ATM?",
  faq2Question: "Where is CashOver supported?",
  rootClassName: "",
};

FAQPersonal.propTypes = {
  faq5Question: PropTypes.string,
  content2: PropTypes.string,
  faq1Question: PropTypes.string,
  heading2: PropTypes.string,
  text: PropTypes.string,
  faq3Question: PropTypes.string,
  faq4Question: PropTypes.string,
  faq2Question: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default FAQPersonal;
